import React, {Component} from 'react'

export default class HelpYourReferrals extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className="helpYourReferrals">
                <h4>Help your referrals</h4>
                <ul>
                    <li>
                        <p>Ivan Ivanov</p>
                        <p>64 days</p>
                        <p>without activity</p>
                    </li>
                    <li>
                        <p>Ivan Ivanov</p>
                        <p>64 days</p>
                        <p>without activity</p>
                    </li>
                    <li>
                        <p>Ivan Ivanov</p>
                        <p>64 days</p>
                        <p>without activity</p>
                    </li>
                    <li>
                        <p>Ivan Ivanov</p>
                        <p>64 days</p>
                        <p>without activity</p>
                    </li>
                </ul>
            </div>
        )
    }
}